import { Routes, Route } from 'react-router-dom';
import NotFound from './pages/NotFound/NotFound';
import BrandingPage from './BrandingPage';
import ClientGuard from './ClientGuard';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import TermsOfService from './pages/legal/TermsOfService';
import RegisterPage from './pages/register/RegisterPage';
import AdminPage from './pages/superadmin/AdminPage';
import LoyaltyCardPage from './pages/public/loyalty-card';
import { useEffect, useState } from 'react';

const AppRoutes = () => {
    const [clientSlug, setClientSlug] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // El slug del negocio es el subdominio del dominio raíz (mibarber.turnlink.app).
        // Se compara contra REACT_APP_ROOT_DOMAIN y no contra "más de 2 partes": en
        // hosts como xyz.up.railway.app (staging/preview) eso tomaba "xyz" como slug
        // y nunca se veía la landing. Fuera del dominio raíz (localhost, railway) se
        // usa path-based routing.
        const hostname = window.location.hostname;
        const rootDomain = (process.env.REACT_APP_ROOT_DOMAIN || 'turnlink.app').toLowerCase();
        const suffix = `.${rootDomain}`;
        if (hostname.endsWith(suffix)) {
            const sub = hostname.slice(0, -suffix.length);
            setClientSlug(sub && sub !== 'www' && !sub.includes('.') ? sub : null);
        } else {
            setClientSlug(null);
        }

        setIsLoading(false);
    }, []);

    if (isLoading) {
        return <div></div>;
    }

    // Si hay slug en subdomain, mostrar Home del cliente
    if (clientSlug) {
        return (
            <Routes>
                {/* Tarjeta de lealtad del cliente final: el token del link es la llave, no hace falta el slug. */}
                <Route path="/tarjeta/:token" element={<LoyaltyCardPage />} />
                <Route path="*" element={<ClientGuard clientSlug={clientSlug} />} />
            </Routes>
        );
    }

    // Si no hay slug en subdomain, usar path-based routing (desarrollo)
    return <PathBasedRouter />;
};

const PathBasedRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<BrandingPage />} />
            <Route path="/registro" element={<RegisterPage />} />
            {/* Superadmin: ruta propia (antes vivía en "/" y cada recarga cerraba la sesión).
                Va antes de /:clientSlug para que "admin" no se interprete como negocio. */}
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            {/* Desarrollo: http://localhost:3000/slug */}
            <Route path="/:clientSlug/tarjeta/:token" element={<LoyaltyCardPage />} />
            <Route path="/:clientSlug" element={<ClientGuard />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    )
}

export default AppRoutes;